module.exports = __webpack_public_path__ + "img/076-suriname.d04e13ea.svg";